import { IconProps } from './IconProps';

export const UhxBetaIcon = (props: IconProps) => {
  return (
    <svg
      className={props.className}
      style={props.style}
      width="25"
      height="25"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.12701 4.09765L9.79701 4.32457C9.91786 4.36485 9.91786 4.53671 9.79701 4.57699L9.12701 4.80391C8.96857 4.85762 8.8437 4.98249 8.78999 5.14093L8.56308 5.81093C8.5228 5.93177 8.35093 5.93177 8.31065 5.81093L8.08374 5.14093C8.03003 4.98249 7.90516 4.85762 7.74672 4.80391L7.07672 4.57699C6.95587 4.53671 6.95587 4.36485 7.07672 4.32457L7.74672 4.09765C7.90516 4.04394 8.03003 3.91907 8.08374 3.76064L8.31065 3.09063C8.35093 2.96979 8.5228 2.96979 8.56308 3.09063L8.78999 3.76064C8.8437 3.91907 8.96857 4.04394 9.12701 4.09765ZM11.9668 5.39336C11.905 5.2121 11.6499 5.2121 11.5882 5.39336L11.2793 6.30774C11.1719 6.62461 10.9235 6.87435 10.6053 6.98177L9.69094 7.29059C9.50968 7.35235 9.50968 7.60747 9.69094 7.66923L10.6053 7.97805C10.9222 8.08546 11.1719 8.33386 11.2793 8.65208L11.5882 9.56646C11.6499 9.74772 11.905 9.74772 11.9668 9.56646L12.2756 8.65208C12.383 8.33521 12.6314 8.08546 12.9497 7.97805L13.864 7.66923C14.0453 7.60747 14.0453 7.35235 13.864 7.29059L12.9497 6.98177C12.6328 6.87435 12.383 6.62596 12.2756 6.30774L11.9668 5.39336ZM2.18126 9.92628L3.51053 10.3747C4.18456 10.603 4.71493 11.132 4.94184 11.8061L5.3903 13.1353C5.47221 13.377 5.81325 13.377 5.89515 13.1353L6.34361 11.8061C6.57187 11.132 7.10089 10.6017 7.77493 10.3747L9.10419 9.92628C9.34588 9.84438 9.34588 9.50333 9.10419 9.42143L7.77493 8.97297C7.10089 8.74471 6.57053 8.21569 6.34361 7.54166L5.89515 6.21239C5.81325 5.97071 5.47221 5.97071 5.3903 6.21239L4.94184 7.54166C4.71358 8.21569 4.18456 8.74605 3.51053 8.97297L2.18126 9.42143C1.93958 9.50333 1.93958 9.84438 2.18126 9.92628Z"
        fill="black"
      />
    </svg>
  );
};

